var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['lk-toggle-btn', { 'lk-toggle-btn--inherit-color': _vm.inheritColor }],attrs:{"type":"button"},on:{"click":function($event){_vm.mv = !_vm.mv}}},[(_vm.mv)?_vm._t("start-state"):_vm._t("end-state")],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/lk/lk-toggle-btn/index.vue?vue&type=template&id=2b77021c&scoped=true&
// module id = 1343
// module chunks = 0